<script>
import WaermeSignupForm from "../components/ui/waerme/WaermeSignupForm.vue";
import Waerme1stParagraph from "../components/ui/waerme/Waerme1stParagraph.vue";
import WaermeBenefits from "../components/ui/waerme/WaermeBenefits.vue";
import WaermeProcessSteps from "../components/ui/waerme/WaermeProcessSteps.vue";
import WaermeModelCards from "../components/ui/waerme/WaermeModelCards.vue";
import WaermeFaq from "../components/ui/waerme/WaermeFaq.vue";
import WaermeContact from "../components/ui/waerme/WaermeContact.vue";
import Breadcrumbs from "@/components/ui/Breadcrumbs.vue";
export default {
  components: {
    Breadcrumbs,
    WaermeSignupForm,
    Waerme1stParagraph,
    WaermeBenefits,
    WaermeProcessSteps,
    WaermeModelCards,
    WaermeFaq,
    WaermeContact
  }
};
</script>

<template>
  <div class="new-wrapper min-height-100 px-5">
    <breadcrumbs />
    <Waerme1stParagraph class="spacing-top" />
    <WaermeBenefits class="spacing-top" />
    <WaermeProcessSteps class="spacing-top" />
    <v-row class="mt-8">
      <v-col cols="12" md="4">
        <v-img src="@/assets/waerme-img3v2.png" />
      </v-col>
      <v-col cols="12" md="4">
        <v-img src="@/assets/waerme-img4v2.png" />
      </v-col>
      <v-col cols="12" md="4">
        <v-img src="@/assets/waerme-img5v2.png" />
      </v-col>
    </v-row>
    <WaermeModelCards class="spacing-top" />
    <v-row class="mt-8">
      <v-col cols="12">
        <WaermeSignupForm id="WaermeSignupForm" />
      </v-col>
    </v-row>
    <WaermeFaq class="spacing-top" />
    <WaermeContact class="spacing-top" />
  </div>
</template>

<style scoped>

</style>
